import { Action, createReducer, on } from '@ngrx/store';
import {
    AccessVisibility,
    SystemEntity,
} from '@wdx/clmi/clmi-swagger-gen';
import {
    CrudStatus,
    CrudStatusRecord,
    setCrudStatus,
} from '@wdx/shared/utils';
import * as visibilityActions from './visibility.actions';

export interface State {
    visibility?: {
        [entityType: string]: {
            [entityId: string]: CrudStatusRecord<AccessVisibility[]>;
        };
    };
}

export const initialState: State = {
    visibility: {},
};

const reducerSetup = createReducer(
    initialState,

    on(
        visibilityActions.getVisibilityForId,
        (state, props): State => ({
            ...state,
            visibility: {
                ...state.visibility,
                [props.entityType]: {
                    ...(state.visibility[props.entityType] || {}),
                    [props.entityId]: {
                        ...(state.visibility[props.entityType]?.[props.entityId] ||
                            {}),
                        ...setCrudStatus(CrudStatus.Loading),
                    },
                },
            },
        }),
    ),

    on(
        visibilityActions.getVisibilityForIdSuccess,
        (state, props): State => ({
            ...state,
            visibility: {
                ...state.visibility,
                [props.entityType]: {
                    ...state.visibility[props.entityType],
                    [props.entityId]: {
                        ...state.visibility[props.entityType]?.[props.entityId],
                        ...setCrudStatus(CrudStatus.Success),
                        record: props.visibility,
                    },
                },
            },
        }),
    ),

    on(
        visibilityActions.getVisibilityForIdFailure,
        (state, props): State => ({
            ...state,
            visibility: {
                ...state.visibility,
                [props.entityType]: {
                    ...state.visibility[props.entityType],
                    [props.entityId]: {
                        ...state.visibility[props.entityType]?.[props.entityId],
                        ...setCrudStatus(CrudStatus.Error),
                    },
                },
            },
        }),
    ),
);

export function reducer(state: State | undefined, action: Action) {
    return reducerSetup(state, action);
}
